import { Link } from "react-router-dom";

export function Logo({ dark = false, className = "" }) {
  const gold = "#D4AF37";
  const text = dark ? "text-[#0A1128]" : "text-white";
  return (
    <Link to="/" className={`flex items-center gap-2.5 group ${className}`} data-testid="brand-logo">
      <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-lg" style={{ background: gold }}>
        <span className="font-display font-semibold text-[#0A1128] text-lg leading-none">P</span>
        <span className="absolute -right-0.5 -top-0.5 h-2 w-2 rounded-full" style={{ background: "#0A1128" }} />
      </span>
      <span className={`font-display font-semibold leading-none ${text}`}>
        Pistone <span className="text-[#D4AF37]">Parla Chiaro</span>
      </span>
    </Link>
  );
}
